module.exports = __webpack_public_path__ + "honor-certificate-02.jpg?2c5f707d89768ecf7ecac05cf5a02001";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/honor-certificate-02.jpg
// module id = 152
// module chunks = 0